import React from "react";
import { Badge } from "reactstrap";
import TimeField from "react-simple-timefield";
const PlaceVisit = ({
  visit,
  planIndex,
  day,
  index,
  updateScheduleBuilderProps,
  removeVisitFromDay
}) => {
  return (
    <div
      className="schedule-builder-visit"
    >
      <div
        className="schedule-builder-visit__meta"
      >
        <span>{visit.name}</span>
        <Badge color="info" style={{ color: "white" }}>
          {visit.score}
        </Badge>
      </div>
      <div className="schedule-builder-visit__actions">
        <span>
          <i
            className="fa fa-clock-o "
            style={{ color: "black", marginRight: 5 }}
          />
          <TimeField
            style={{
              border: "0px",
              borderBottom: "1px solid #555",
              width: 40,
              borderRadius: 3
            }}
            value={visit.time}
            onChange={T => {
              updateScheduleBuilderProps([
                {
                  prop:
                    "plans." +
                    planIndex +
                    "." +
                    day +
                    ".visits." +
                    index +
                    ".time",
                  value: T
                }
              ]);
            }}
          />
        </span>
        <i
          onClick={() => {
            removeVisitFromDay(planIndex, day, index);
          }}
          className="fa fa-times-circle "
          style={{ color: "red", marginLeft: 20, justifySelf: "flex-end" }}
        />
      </div>
    </div>
  );
};

export default PlaceVisit;
